import React, { useState } from "react";
import "../Styles/contactus.css";
import Navbar from "../sections/common/Navbar";
import Footer from "../sections/common/Footer";
import { contactUsApi } from "../apis/contactUs/contact";

function ContactUs() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name: name,
      email: email,
      phone: phone,
      subject: subject,
      message: message,
    };
    const response = await contactUsApi(
      data,
      setName,
      setEmail,
      setPhone,
      setSubject,
      setMessage
    );
    console.log("response from signUpApi", response);
  };

  return (
    <div>
      <Navbar />
      <section className="listing-banner">
        <h1>Contact Us</h1>
      </section>
      <section className="container blog-details-page-location">
        <p>Home / Contact-Us</p>
      </section>

      <section>
        <div className="container my-5">
          <div className="row contact-row">
            <div className="col-sm-12 col-md-4 col-xl-4">
              <div className="contact_us_box">
                <div className="contact_us_box_icon">
                  <img src="/images/contactus_images/distance.png" alt="img" />
                </div>
                <h3>Address</h3>
                <p>254 S Brooklyn, New York</p>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-xl-4">
              <div className="contact_us_box">
                <div className="contact_us_box_icon">
                  <img src="/images/contactus_images/call.png" alt="img" />
                </div>
                <h3>Phone No.</h3>
                <p>(+0) 123 456 789</p>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-xl-4">
              <div className="contact_us_box">
                <div className="contact_us_box_icon">
                  <img src="/images/contactus_images/mail.png" alt="img" />
                </div>
                <h3>Email</h3>
                <p>Info@domainname.com</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container pb-5">
          <div className="contact_us_form_main d-flex justify-content-center py-5">
            <form className="col-md-8 col-lg-6" onSubmit={handleSubmit}>
              <div>
                <h2 className="text-center">GET IN TOUCH</h2>
                <div className="row mb-3">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Message"
                    rows="5"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div>
                  <button
                    type="submit"
                    className="contact_us_submit_btn btn w-100"
                  >
                    Submit Now
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ContactUs;
